
<ng-container *ngIf="this.data.plan !== undefined"s>
  <form fxLayout="column" [formGroup]="form">
    <div matDialogTitle>Copy Plan</div>

    <div mat-dialog-content fxLayout="column" fxLayoutGap="5px">
      <!-- Plan Name -->
      <mat-form-field fxFlex>
        <input type="text" placeholder="Plan name" matInput formControlName="name" />
        <mat-error *ngIf="controls.name.errors && (controls.name.dirty || controls.name.touched) && controls.name.errors?.required">
          Plan name is <strong>required</strong>.
        </mat-error>
      </mat-form-field>

      <div fxLayout="row" fxLayoutGap="20px">
        <!-- Start Date -->
        <mat-form-field fxFlex>
          <input placeholder="Start date" matInput formControlName="startDate" [matDatepicker]=startDatepicker />
          <mat-datepicker-toggle matSuffix [for]="startDatepicker"></mat-datepicker-toggle>
          <mat-datepicker #startDatepicker></mat-datepicker>
          <mat-error
            *ngIf="controls.startDate.errors && (controls.startDate.dirty || controls.startDate.touched) && controls.startDate.errors?.required"
          >
            The start date of the plan is <strong>required</strong>.
          </mat-error>
        </mat-form-field>

        <!-- Number of weeks -->
        <mat-form-field fxFlex>
          <input type="number" placeholder="Number of weeks" matInput formControlName="numWeeks" />
          <mat-error
            *ngIf="controls.numWeeks.errors && (controls.numWeeks.dirty || controls.numWeeks.touched) && controls.numWeeks.errors?.required"
          >
            Plan length in weeks is <strong>required</strong>.
          </mat-error>
          <mat-error *ngIf="controls.numWeeks.errors && controls.numWeeks.errors?.min">
            Plan must be a minimum of 1 week long.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Note -->
      <mat-form-field fxFlex>
        <textarea matInput placeholder="Notes" rows="3" formControlName="notes"></textarea>
      </mat-form-field>

      <!-- Displayed groups/users Tittles -->
      <!-- <div fxLayout="row" fxLayoutGap="20px">
        <span fxFlex="50" class="list-title">
            Published Groups
        </span>
        <span fxFlex="50" class="list-title">
            Shared With Users
        </span>
      </div> -->

      <!-- Displayed Groups -->
      <!-- <div fxLayout="row" fxLayoutGap="20px">
        <div fxFlex="50" class="list-container">
          <ng-container *ngIf="displayedGroups.length > 0">
            <div
              formArrayName="publishedToGroups"
              *ngFor="let group of form.controls.publishedToGroups.controls; let i = index"
            >
              <mat-checkbox [formControlName]="i" >
                  {{ displayedGroups[i].name }}
              </mat-checkbox>
            </div>
          </ng-container>
          <p class="help-text" *ngIf="!this.isOnline">Currently offline: can't publish</p>
          <p class="help-text" *ngIf="this.isOnline && displayedGroups.length === 0 ">Not published</p>
        </div> -->

        <!-- Displayed Users -->
        <!-- <div fxFlex="50" class="list-container">
            <ng-container *ngIf="displayedUsers.length > 0 ">
            <div
              formArrayName="sharedWithUsers"
              *ngFor="let group of form.controls.sharedWithUsers.controls; let i = index"
            >
              <mat-checkbox [formControlName]="i" >
                  {{ displayedUsers[i].lastName}}, {{ displayedUsers[i].firstName  }}
              </mat-checkbox>
            </div>
          </ng-container>
          <p class="help-text" *ngIf="!this.isOnline">Currently offline: can't publish</p>
          <p class="help-text" *ngIf="this.isOnline && displayedUsers.length === 0 ">Not Shared</p>
          </div>
      </div> -->
    </div>

    <!-- Buttons -->
    <mat-dialog-actions fxLayout="row" fxLayoutAlign="end center">
      <button mat-button matDialogClose [disabled]="saving">Cancel</button>
      <button mat-raised-button [disabled]="form.invalid || saving" (click)="save()" color="primary">
        Save
        <mat-spinner *ngIf="saving" color= "accent" class="spinner"></mat-spinner>

      </button>
    </mat-dialog-actions>
  </form>
</ng-container>

<div *ngIf="this.data.plan === undefined">
  Component Error: Passed undefined plan metadata.
</div>
